// extracted by mini-css-extract-plugin
export default {"NoAccessContainer":"noAccess_NoAccessContainer__M05wh","iconWrapper":"noAccess_iconWrapper__7HwKO","noAccessNotification":"noAccess_noAccessNotification__bHhvz"};